import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Category } from "@insite/client-framework/Services/CategoryService";
import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { BrandModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    carouselId: string;
    carouselType: string;
    relatedProductType: string;
    seedWithManuallyAssigned: string;
    displayProductsFrom: string;
    selectedCategoryIds: string[];
    numberOfProductsToDisplay: number;
    isProductDetailsPage: boolean;
    productId?: string;
    isProductListPage: boolean;
    category?: Category;
    isBrandDetailsPage: boolean;
    brand?: BrandModel;
    isShellEdit?: boolean;
    widgetPosition?: number;
}

interface Props {
    getProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    extraProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    additionalSort?: (products: ProductModel[]) => ProductModel[];
}

type HandlerType = Handler<Parameter, Props>;

export const LoadProductsExtended: HandlerType = ({
    dispatch,
    getProductCollectionParameter,
    extraProductCollectionParameter,
    additionalSort,
    parameter: { carouselId, carouselType, numberOfProductsToDisplay, isProductDetailsPage, productId, isShellEdit },
}) => {
    if (!getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = extraProductCollectionParameter
        ? {
              getProductCollectionParameter: extraProductCollectionParameter,
              numberOfProductsToDisplay,
          }
        : undefined;

    const isRecentlyViewedOnPDP = carouselType === "recentlyViewed" && isProductDetailsPage;

    getProductCollectionParameter.expand
        ? getProductCollectionParameter.expand.push("images", "badges", "properties")
        : (getProductCollectionParameter.expand = ["images", "badges", "properties"]);

    dispatch(
        loadProductInfoList({
            id: carouselId,
            getProductCollectionParameter,
            extraProductOptions,
            excludeProductId: isRecentlyViewedOnPDP ? productId : undefined,
            forceLoad: isRecentlyViewedOnPDP,
            isShellEdit,
            additionalSort,
        }),
    );
};

replaceInChain(chain, LoadProducts, LoadProductsExtended);
